<template>
    <div class="service-notice">
        <div class="background" />
        <div class="main">
            <p class="hold">⚠️ Songkran Warning 💦</p>
            <p>Due to Songkran Festival there is a lot of traffic, some roads are completely blocked and many restaurants
                are closed.</p>
            <p class="has-text-weight-bold" style="padding: 12px 0">If your order is successful, delivery will take at
                least twice as long as normal.
            </p>

            <p class="buttons" style="margin: 16px 0">
                <span class="button is-fullwidth is-medium is-warning is-capitalized pulse" @click="close"><i
                        class="fa fa-check-double" />&nbsp;I
                    Acknowledge</span>
            </p>
        </div>
    </div>
</template>


<script>
export default {
    name: "ServiceNotice",
    data() {
        return {};
    },
    computed: {
        // phone() {
        //     return this.$store.getters.phoneNumber;
        // },
        // nameAndNumber() {
        //     return this.$store.getters.getNameAndNumber;
        // },
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.service-notice {
    position: relative;
    z-index: 999999;
}

.background {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(1px);
}

.main {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 20px;
    /* padding-bottom: 40px; */
    /* border: 6px solid yellow; */
    background-color: blue;
    color: white;
    text-align: left;
}

.hold {
    text-align: center;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 1.2em;
}

.pulse {
    animation: shadow-pulse 2s ease-out infinite;
    border-radius: 3px;
}

@keyframes shadow-pulse {
    0% {
        box-shadow: inset 0 0 0 0px rgba(255, 0, 0, 1);
    }

    50% {
        box-shadow: inset 0 0 0 6px rgba(255, 0, 0, 0.7);
    }

    100% {
        box-shadow: inset 0 0 0 0px rgba(255, 0, 0, 1);
    }
}
</style>